function FAQ(props){

    const { question, onClick, currentQuestion, answer, questionId} = props
    return(
         <div className="flex one column border shadow">
            <div className="flex one" onClick={()=>{onClick(questionId)}}>
                <div className="flex five  center">
                    <span className="bold">{question}</span>
                </div>
            </div>
            <div className={`flex one center padding ${ currentQuestion == questionId ? 'visible':'invisible'}`}>
                <span>{answer}</span>
            </div>
         </div>
    )
}

export default FAQ;